import { createReducer } from '@cbgms/base/utils/redux'
import * as types from './types'
import moment from 'moment'
import { IListShopByCompanyUUID, IShopByCompany } from '@cbgms/api'
import { AnyAction } from 'redux'

const defaultState = [] as IShopByCompany[]

export const shops = (state: IShopByCompany[] = defaultState, action: AnyAction) => {
  switch (action.type) {
    case types.GET_SHOPS_BY_COMPANY_UUID_SUCCESS:
      return (action.payload.data.Data as IListShopByCompanyUUID[]).map(({ Shop }) => Shop)
    default:
      return state
  }
}

export const shop = createReducer(
  {},
  {
    [types.GET_SHOP_SUCCESS](_: any, { payload }: any) {
      return payload.data.Data
    },
    [types.RESET_SHOP_STATE]() {
      return {}
    },
    [types.ADD_SHOP_TO_CRM_SUCCESS](state: any) {
      return {
        ...state,
        postShopToCRMDateTime: moment()
      }
    }
  }
)
